<template>
    <div class="check_summary">
        <div class="ui form">
            <h5 class="ui header" v-if="senders.length > 0">
                寄件人
                <div class="right floated">
                    <a href="#" @click.prevent="select_all_sender()" style="font-size: 0.7em;">
                        <span v-if="is_all_sender_selected">
                            <!-- 取消全部 -->
                            {{ $t('ui.general.cancel')}}
                            {{ $t('ui.general.all') }}
                        </span>
                        <span v-else>
                            <!-- 選擇全部 -->
                            {{ $t('ui.general.select')}}
                            {{ $t('ui.general.all') }}
                        </span>
                    </a>
                </div>
            </h5>
            <div class="field" v-for="sender in senders">
                <div class="ui checkbox" v-checkbox>
                    <input type="checkbox" tabindex="0" class="hidden" v-model="sender.is_selected">
                    <label>{{ sender.sender_name }}</label>
                </div>
            </div>
            <h5 class="ui header" v-if="consignees.length > 0">
                收件人
                <div class="right floated">
                    <a href="#" @click.prevent="select_all_consignee()" style="font-size: 0.7em;">
                        <span v-if="is_all_consignee_selected">
                            <!-- 取消全部 -->
                            {{ $t('ui.general.cancel')}}
                            {{ $t('ui.general.all') }}
                        </span>
                        <span v-else>
                            <!-- 選擇全部 -->
                            {{ $t('ui.general.select')}}
                            {{ $t('ui.general.all') }}
                        </span>
                    </a>
                </div>
            </h5>
            <div class="field" v-for="consignee in consignees">
                <div class="ui checkbox" v-checkbox>
                    <input type="checkbox" tabindex="0" class="hidden" v-model="consignee.is_selected">
                    <label>{{ consignee.consignee_name }}</label>
                </div>
            </div>
        </div>
        <div class="ui basic buttons" v-if="show_buttons && is_printing">
            <div class="ui active inline loader"></div>
        </div>
        <div class="ui basic buttons" v-if="show_buttons && !is_printing">
            <div class="ui button" @click="refresh_data">
                <i class="arrow alternate circle down outline icon"></i>
                抓取資料
            </div>
            <div class="ui button" @click="print('NormalLayout')">
                <i class="print icon"></i>
                列印點交單(A4)
            </div>
            <div class="ui button" @click="print('SimpleLayout')">
                <i class="print icon"></i>
                列印點交單(連續紙)
            </div>
        </div>
        <NormalLayout
        :show_contents="show_contents"
        :core_waybills="core_waybills"
        :logo_url="logo_url"
        :title="title"
        :sub_title="sub_title"
        :customer_service_hotline="customer_service_hotline"
        :blank_value_text="blank_value_text"
        >
        </NormalLayout>
        <SimpleLayout
        :show_contents="show_contents"
        :core_waybills="core_waybills"
        :logo_url="logo_url"
        :title="title"
        :sub_title="sub_title"
        :customer_service_hotline="customer_service_hotline"
        :blank_value_text="blank_value_text"
        >
        </SimpleLayout>
    </div>
</template>

<script>
import NormalLayout from "./normal_layout.vue"
import SimpleLayout from "./simple_layout.vue"
export default {
    name: "ToolCheckSummaryMain",
    props: {
        show_buttons: {
            type: Boolean,
            default: false,
        },
        show_contents: {
            type: Boolean,
            default: false,
        },
        assigned_core_waybills: {
            type: Array,
            default() {
                return []
            }
        },
        logo_url: {
            type: String,
            default: '/images/tw568_logo.png'
        },
        title: String,
        sub_title: String,
        customer_service_hotline: String,
        blank_value_text: {
            type: String,
            default: "-",
        },
        channel_name: {
            type: String,
            default: 'check_summary',
        },
        is_beta: {
            type: Boolean,
            default: false,
        },
        conditions_search_params: {
            type: Object,
            default() {
                return {}
            }
        },
        default_search_params: {
            type: Object,
            default() {
                return {}
            }
        },
        scope: String,
    },
    model: {
        prop: 'value', // return Array
        event: 'update'
    },
    data () {
        return {
            is_printing: false,
            core_waybill_identities: [],
            core_waybills: [],
            errors: [],
            senders: [],
            consignees: []
        }
    },
    mounted() {
        // print channel
        this.$bus.$off(this.channel_name)
        this.$bus.$on(this.channel_name,(order, params) => {
            switch (order) {
                case "refresh_data":
                    this.refresh_data()
                    break
                case "print":
                    this.print(params)
                    break
                default:

            }
        })
    },
    computed: {
        check_core_waybills() {
            var allowed_sender_names = _.map(_.filter(this.senders, (o) => { return o.is_selected}), 'sender_name')
            var allowed_consignee_names = _.map(_.filter(this.consignees, (o) => { return o.is_selected}), 'consignee_company_name')
            return _.filter(
                this.core_waybills,
                (o) => {
                    return allowed_sender_names.includes(o.sender_name) && allowed_consignee_names.includes(o.consignee_company_name)
                }
            )
        },
        is_all_sender_selected() {
            return !_.findLast(this.senders, sender => !sender.is_selected)
        },
        is_all_consignee_selected() {
            return !_.findLast(this.consignees, consignee => !consignee.is_selected)
        }
    },
    methods: {
        async print(layout) {
            if (!this.is_printing) {
                await new Promise(resolve => {
                    this.is_printing = true
                    resolve()
                })
                // 初始化列印空間
                await new Promise(resolve => {
                    $("div#print").html("")
                    resolve()
                })
                await this.$nextTick(() => {
                    window.Noty.closeAll()
                })
                // 等待列印內容轉錄至列印空間
                for(let child of _.filter(this.$children, (o) => {return o.$options._componentTag == layout})) {
                    await new Promise(resolve => {
                        $(child.$refs.printable_check_summaries).clone().appendTo('div#print')
                        resolve()
                    })
                }
                // 呼叫列印視窗
                await new Promise(resolve => {
                    window.print()
                    this.is_printing = false
                    resolve()
                })
            }
        },
        async refresh_data() {
            try {
                await new Promise(resolve => {
                    this.core_waybills = []
                    this.core_waybills = this.assigned_core_waybills
                    resolve()
                })
                if (this.core_waybills.length == 0) {
                    if (this.is_beta) {
                        this.$emit('update', true)
                        await this.fetch_core_waybill_identities()
                        await this.fetch_core_waybills()
                    } else {
                        await this.old_fetch_core_waybills()
                    }
                }
            } catch (e) {

            } finally {
                this.$emit('update', false)
            }
        },
        fetch_core_waybill_identities() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_conditions_core_waybill_identities).parse()

            return axios.post(
                url,
                this.conditions_search_params,
                {
                    headers: {
                        Authorization: localStorage.getItem("authentication_token")
                    }
                }
            ).then(response => {
                if (response.data.status == "success") {
                    this.core_waybill_identities = response.data.core_waybill_identities
                } else if (response.data.status == "failure") {
                    // this.$noty.error("抓取運單失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.core_waybills'),
                            reason: ': ' + response.data.errors
                        })
                    )
                }
                return response
            }).catch(error => {
                this.$noty.error(
                    this.$t('ui.notifications.error.fetch__name', {
                        name: this.$t('models.core_waybills'),
                        reason: ': ' +this.$t('ui.general.network_abnormality')
                    })
                )

                return Promise.reject(error)
            })
        },
        fetch_core_waybills() {
            switch (this.scope) {
                case "provider":
                    var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybills_filter).parse()
                    var token = localStorage.getItem("authentication_token")
                    break
                case "customer":
                    var url = new RestUrl(this.$store.state.customer.routes.api_v1_customer_core_waybills_filter).parse()
                    var token = localStorage.getItem("customer_authentication_token")
                    break
            }
            this.senders = []
            this.consignees = []
            return axios.post(
                url,
                {
                    identity: this.core_waybill_identities,
                    pagination: false
                },
                {
                    headers: {
                        Authorization: token
                    }
                }
            ).then((response) => {
                if (response.data.status == "success") {
                    if (response.data.core_waybills) {
                        this.core_waybills = response.data.core_waybills
                    }
                    this.senders = []
                    this.consignees = []
                    for(let sender_name of _.uniq(_.map(response.data.core_waybills, 'sender_name'))) {
                        this.senders.push({
                            sender_name: sender_name,
                            is_selected: true,
                        })
                    }
                    for(let consignee_name of _.uniq(_.map(response.data.core_waybills, 'consignee_company_name'))) {
                        this.consignees.push({
                            consignee_name: consignee_name,
                            is_selected: true,
                        })
                    }
                    // this.$noty.success("成功抓取點交資料")
                    this.$noty.success(
                        this.$t('ui.notifications.success.fetch__name', {
                            name: '點交資料'
                        })
                    )
                } else if (response.data.status == "failure") {
                    return Promise.reject(response.data)
                }
            }).catch((error) => {
                this.$emit('update', false)
                if (error.response) {
                    switch (error.response.status) {
                        default:
                        this.errors.push(error.response.status + ' ' + error.response.statusText)
                    }
                    // this.$noty.error('取得點交資料失敗: ' + error.response.status + ' ' + error.response.statusText)
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: '點交資料',
                            reason: ': ' + error.response.status + ' ' + error.response.statusText
                        })
                    )

                } else if (error.errors) {
                    // this.$noty.error('取得點交資料失敗: ' + error.errors)
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: '點交資料',
                            reason: ': ' + error.errors
                        })
                    )
                    this.errors = response.data.errors
                } else {
                    this.errors.push(this.$t('ui.general.server_offline'))
                    this.$noty.error(this.$t('ui.general.server_offline'))
                }
                return Promise.reject(error)
            })
        },
        old_fetch_core_waybills() {
            switch (this.scope) {
                case "provider":
                    var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybills_filter).parse(
                        {},
                        "?" + object_to_query(this.default_search_params)
                    )
                    var token = localStorage.getItem("authentication_token")
                    break
                case "customer":
                    var url = new RestUrl(this.$store.state.customer.routes.api_v1_customer_core_waybills_filter).parse(
                        {},
                        "?" + object_to_query(this.default_search_params)
                    )
                    var token = localStorage.getItem("customer_authentication_token")
                    break
            }
            this.senders = []
            this.consignees = []
            return axios.get(url, {headers: { Authorization: token }})
                .then((response) => {
                    if (response.data.status == "success") {
                        if (response.data.core_waybills) {
                            this.core_waybills = this.core_waybills.concat(response.data.core_waybills)
                        }
                        this.pagination = response.data.pagination
                        this.senders = []
                        this.consignees = []
                        for(let sender_name of _.uniq(_.map(response.data.core_waybills, 'sender_name'))) {
                            this.senders.push({
                                sender_name: sender_name,
                                is_selected: true,
                            })
                        }
                        for(let consignee_name of _.uniq(_.map(response.data.core_waybills, 'consignee_company_name'))) {
                            this.consignees.push({
                                consignee_name: consignee_name,
                                is_selected: true,
                            })
                        }
                        // this.$noty.success("成功抓取點交資料")
                        this.$noty.success(
                            this.$t('ui.notifications.success.fetch__name', {
                                name: '點交資料'
                            })
                        )
                    } else if (response.data.status == "failure") {
                        return Promise.reject(response.data)
                    }
                })
                .catch((error) => {
                    this.$emit('update', false)
                    if (error.response) {
                        switch (error.response.status) {
                            default:
                            this.errors.push(error.response.status + ' ' + error.response.statusText)
                        }
                        // this.$noty.error('取得點交資料失敗: ' + error.response.status + ' ' + error.response.statusText)
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: '點交資料',
                                reason: ': ' + error.response.status + ' ' + error.response.statusText
                            })
                        )

                    } else if (error.errors) {
                        // this.$noty.error('取得點交資料失敗: ' + error.errors)
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: '點交資料',
                                reason: ': ' + error.errors
                            })
                        )
                        this.errors = response.data.errors
                    } else {
                        this.errors.push(this.$t('ui.general.server_offline'))
                        this.$noty.error(this.$t('ui.general.server_offline'))
                    }
                    return Promise.reject(error)
                })
        },
        latest_status_time(core_waybill) {
            try {
                return this.human_datetime(core_waybill.latest_status.created_at, "MMDDHHmm")
            } catch (e) {
                return "-"
            }
        },
        select_all_sender() {
            var current_selected = this.is_all_sender_selected
            for (let sender of this.senders) {
                sender.is_selected = !current_selected
            }

        },
        select_all_consignee() {
            var current_selected = this.is_all_consignee_selected
            for (let consignee of this.consignees) {
                consignee.is_selected = !current_selected
            }
        },
    },
    components: {
        NormalLayout,
        SimpleLayout,
    }
}
</script>

<style scoped>
table {
    border-color:  black !important;
}
table td, th{
    border-color:  black !important;
}
</style>
